import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetRoadPlansInputDto, ImportRoadPlansInputDto, RoadPlanCreateDto, RoadPlanDto, RoadPlanExcelDownloadDto, RoadPlanUpdateDto } from '../dtos/road-plan/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class RoadPlanService {
  private restService = inject(RestService);
  apiName = 'Operational';
  

  create = (input: RoadPlanCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, RoadPlanDto>({
      method: 'POST',
      url: '/api/operational/roadPlans',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/operational/roadPlans/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/operational/roadPlans',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, RoadPlanDto>({
      method: 'GET',
      url: `/api/operational/roadPlans/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/operational/roadPlans/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetRoadPlansInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<RoadPlanDto>>({
      method: 'GET',
      url: '/api/operational/roadPlans',
      params: { planTypeId: input.planTypeId, planVersion: input.planVersion, harvestBlockId: input.harvestBlockId, startDate: input.startDate, startDateFrom: input.startDateFrom, startDateTo: input.startDateTo, periodKilometers: input.periodKilometers, periodKilometersFrom: input.periodKilometersFrom, periodKilometersTo: input.periodKilometersTo, versionId: input.versionId, versionName: input.versionName, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: RoadPlanExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/operational/roadPlans/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, planTypeId: input.planTypeId, planVersion: input.planVersion, harvestBlockId: input.harvestBlockId, startDate: input.startDate, startDateFrom: input.startDateFrom, startDateTo: input.startDateTo, periodKilometers: input.periodKilometers, periodKilometersFrom: input.periodKilometersFrom, periodKilometersTo: input.periodKilometersTo, versionId: input.versionId, versionName: input.versionName, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, RoadPlanDto[]>({
      method: 'GET',
      url: '/api/operational/roadPlans/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  import = (input: ImportRoadPlansInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, RoadPlanDto[]>({
      method: 'POST',
      url: '/api/operational/roadPlans/import',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: RoadPlanUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, RoadPlanDto>({
      method: 'PUT',
      url: `/api/operational/roadPlans/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}